const getSeconds = (milliseconds) => Math.trunc(milliseconds / 1000);

export default getSeconds;
